import { createSelector } from 'reselect';

import { StateDictionary } from '../reducers/utils/state-manager';

export type CommentTemplateState = {
  commentTemplatesById: { [startDateTriggeredCommunicationId: number]: CommentTemplate };
  commentTemplatesStateByJobId: StateDictionary;
  commentTemplatesStateByOrgId: StateDictionary;
};
type State = { commentTemplates: CommentTemplateState };

const commentTemplatesByIdSelector = (state: State) => state.commentTemplates.commentTemplatesById;
const commentTemplatesSelector = createSelector(
  [commentTemplatesByIdSelector],
  (commentTemplatesById) => Object.values(commentTemplatesById),
);

export const commentTemplatesForApplicantsSelector = createSelector(
  [
    commentTemplatesSelector,
    (_state: State, jobId: number) => jobId,
    (_state: State, _jobId: number, orgId: number) => orgId,
  ],
  (commentTemplates, jobId, orgId) =>
    commentTemplates.filter(
      (ct) =>
        ct.profileType === 'applicant' && (ct.jobId === jobId || (ct.orgId === orgId && !ct.jobId)),
    ),
);

export const commentTemplatesForEmployeesSelector = createSelector(
  [commentTemplatesSelector, (_state: State, orgId: number) => orgId],
  (commentTemplates, orgId) =>
    commentTemplates.filter((ct) => ct.profileType === 'employee' && ct.orgId === orgId),
);

const commentTemplatesStateByJobIdSelector = (state: State) =>
  state.commentTemplates.commentTemplatesStateByJobId;
export const commentTemplatesStateForJobIdSelector = createSelector(
  [commentTemplatesStateByJobIdSelector, (_state: State, jobId: number) => jobId],
  (commentTemplatesStateByJobId, jobId) => commentTemplatesStateByJobId[jobId],
);
const commentTemplatesStateByOrgIdSelector = (state: State) =>
  state.commentTemplates.commentTemplatesStateByOrgId;
export const commentTemplatesStateForOrgIdSelector = createSelector(
  [commentTemplatesStateByOrgIdSelector, (_state: State, orgId: number) => orgId],
  (commentTemplatesStateByOrgId, orgId) => commentTemplatesStateByOrgId[orgId],
);
